import React from 'react';

const TermsOfService = () => {
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '40px 24px', fontFamily: 'sans-serif', lineHeight: 1.7, color: '#1a1a2e' }}>
      <h1>Terms of Service</h1>
      <p><strong>Effective Date:</strong> August 1, 2026</p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing or using ChronoFlow ("Service"), you agree to be bound by these Terms of Service ("Terms").
        If you do not agree to these Terms, please do not use the Service.
      </p>

      <h2>2. Description of Service</h2>
      <p>
        ChronoFlow is an AI-powered recruitment scheduling platform that helps recruiters, hiring managers, and
        candidates coordinate interviews and manage the hiring workflow. The Service allows users to sign in via
        Google or Microsoft accounts and integrates with Google Calendar and Microsoft Calendar to facilitate
        interview scheduling.
      </p>

      <h2>3. Eligibility</h2>
      <p>By using the Service, you confirm that you are:</p>
      <ul>
        <li>At least 18 years old</li>
        <li>Authorised to act on behalf of your business entity (if applicable)</li>
        <li>Capable of forming a binding contract with ChronoFlow</li>
      </ul>

      <h2>4. Account Registration and Security</h2>
      <p>
        You may register using Google OAuth, Microsoft OAuth, or email/OTP. You are responsible for maintaining
        the confidentiality of your account and for all activities that occur under your account. You must notify
        us immediately at <a href="mailto:ammara@chronoflow.ai">ammara@chronoflow.ai</a> of any unauthorised use
        of your account.
      </p>

      <h2>5. Use of Third-Party Services (Google and Microsoft)</h2>
      <p>
        When you sign in with Google or Microsoft, you authorise ChronoFlow to access your calendar data solely
        for the purpose of scheduling interviews. Specifically:
      </p>
      <ul>
        <li>We read your calendar availability to display open slots to other authorised parties (recruiters or managers).</li>
        <li>We create calendar events on your behalf when an interview is scheduled.</li>
        <li>We do not access, read, or store any calendar data beyond what is necessary for these scheduling functions.</li>
      </ul>
      <p>
        You may revoke this access at any time via your{' '}
        <a href="https://myaccount.google.com/permissions" target="_blank" rel="noopener noreferrer">Google Account settings</a>{' '}
        or Microsoft account settings. Revoking access will disable calendar-related features in the Service.
      </p>
      <p>
        Your use of Google services through ChronoFlow is also subject to Google's{' '}
        <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>.
      </p>

      <h2>6. Acceptable Use</h2>
      <p>You agree to use the Service only for lawful purposes. You must not:</p>
      <ul>
        <li>Use the Service for any unlawful, fraudulent, or harmful purpose</li>
        <li>Attempt to gain unauthorised access to any part of the Service or its infrastructure</li>
        <li>Upload or transmit viruses, malware, or any other malicious code</li>
        <li>Scrape, reverse engineer, or decompile any part of the Service</li>
        <li>Use the Service to harass, abuse, or harm any person</li>
        <li>Violate any applicable laws or regulations</li>
      </ul>

      <h2>7. Data Privacy</h2>
      <p>
        Your use of the Service is governed by our{' '}
        <a href="/privacy-policy">Privacy Policy</a>, which is incorporated into these Terms by reference.
        By using the Service, you consent to the collection and use of your data as described in the Privacy Policy.
      </p>

      <h2>8. Subscription and Payment</h2>
      <p>
        Certain features of the Service require a paid subscription. Payments are processed securely via Stripe.
        Subscription fees are non-refundable except as required by applicable law. We reserve the right to change
        pricing with reasonable notice to existing subscribers.
      </p>

      <h2>9. Intellectual Property</h2>
      <p>
        All content, trademarks, logos, and intellectual property related to the Service are owned by ChronoFlow
        or its licensors. You may not reproduce, distribute, or create derivative works from any part of the Service
        without our express written permission.
      </p>

      <h2>10. Disclaimer of Warranties</h2>
      <p>
        The Service is provided on an "as is" and "as available" basis without warranties of any kind, express or
        implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or
        non-infringement. We do not warrant that the Service will be uninterrupted, error-free, or free of viruses.
      </p>

      <h2>11. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, ChronoFlow shall not be liable for any indirect, incidental, special,
        consequential, or punitive damages, including but not limited to loss of profits, data, or goodwill, arising
        from your use of or inability to use the Service.
      </p>

      <h2>12. Indemnification</h2>
      <p>
        You agree to indemnify and hold harmless ChronoFlow, its affiliates, officers, directors, and employees from
        any claims, damages, liabilities, and expenses arising out of your use of the Service, your violation of
        these Terms, or your violation of any third-party rights.
      </p>

      <h2>13. Termination</h2>
      <p>
        We reserve the right to suspend or terminate your access to the Service at our discretion, with or without
        notice, if we believe you have violated these Terms or for any other reason. You may terminate your account
        at any time by contacting us at <a href="mailto:ammara@chronoflow.ai">ammara@chronoflow.ai</a>.
      </p>

      <h2>14. Modifications to the Service and Terms</h2>
      <p>
        We reserve the right to modify or discontinue the Service at any time. We may also update these Terms
        periodically. Your continued use of the Service after any changes constitutes your acceptance of the
        updated Terms.
      </p>

      <h2>15. Governing Law</h2>
      <p>
        These Terms shall be governed by and construed in accordance with the laws of the State of California,
        United States, without regard to its conflict of law principles. Any disputes arising under these Terms
        shall be subject to the exclusive jurisdiction of the courts located in San Francisco, California.
      </p>

      <h2>16. Contact Information</h2>
      <p>
        If you have any questions about these Terms, please contact us at:
      </p>
      <p>
        <strong>ChronoFlow</strong><br />
        San Francisco, California, USA<br />
        <a href="mailto:ammara@chronoflow.ai">ammara@chronoflow.ai</a><br />
        <a href="https://chronoflow.ai">https://chronoflow.ai</a>
      </p>
    </div>
  );
};

export default TermsOfService;
